<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <pb-body-base class="search" :busy="busy">
        <template v-slot:default="props">
            <pb-body>
                <template slot="title">
                    <b-row class="mt-7 mb-4">
                        <b-col class="text-center">
                            <h3>search</h3>
                            <hr/>
                        </b-col>
                    </b-row>
                </template>
                <template slot="body" >
                    asdfg
                </template>
            </pb-body>
        </template>
    </pb-body-base>
</template>

<script>



    export default {
        name: 'search',
        props: {},
        components: {

        },
        data() {
            return {
                busy: false
            };
        },
        beforeRouteUpdate(to, from, next) {
        },
        created() {
        },
        methods: {

        },
        computed: {

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
